<template>
  <section class="section">
    <h2> Objectifs </h2>
    <div style="padding-top: 10px; padding-left: 20px;">
      <b-notification
        :closable="false"
        v-if="isLoading"
      >
        Chargement en cours ...
        <b-loading
          :is-full-page="isFullPage"
          :active.sync="isLoading"
          :can-cancel="true"
        ></b-loading>
      </b-notification>
    </div>
    <div class="mycard">
      <div
        v-if="hasTodayGoal && !isAdmin[0]"
        class="today-card"
      >
        <h3> Objectif du jour : </h3>
        <div
          v-if="hasTodayGoal"
          class="today-card-widgets"
        >
          <div class="today-progression-over">
            <div
              class="today-progressbar"
              :style="getProgressWidget(this.myData[0])"
            >
              <b-field
                class="today-progression-content"
                :style="getColor(this.myData[0])"
              >
                <div class="today-progresstext">
                  <span style="color: #FFF; font-weight: 800; font-size: medium;"><i class="fal fa-percent"></i> Progression<br></span>
                  {{ this.myData[0] != undefined && this.myData[0].sales ? (this.myData[0].sales.length / this.myData[0].daily_sales_goal*100).toFixed(2) : 0}}%
                </div>
              </b-field>
            </div>
          </div>

          <div class="today-progression">
            <b-field
              class="today-podium-content"
              style="color: #2aa3d6;"
            >
              <span style="color: #FFF; font-weight: 800; font-size: large;"> <i class="fas fa-trophy"></i> Champions<br></span>
              <span
                v-if="podiumFirst == 'N/A'"
                style="color: #FFF; font-weight: 2000; font-size: medium;"
              > {{ podiumFirst }} <br></span>
              <span
                v-if="podiumFirst != 'N/A'"
                style="color: #D4AF37; font-weight: 2000; font-size: medium;"
              > {{ podiumFirst }} <br></span>
              <span
                v-if="podiumSecond != ''"
                style="color: #9EA7B3; font-weight: 800; font-size: medium;"
              > {{ podiumSecond }} <br></span>
              <span
                v-if="podiumThird != ''"
                style="color: #8B4000; font-weight: 700; font-size: medium;"
              > {{ podiumThird }} <br></span>
            </b-field>
          </div>

          <div class="today-progression">
            <b-field
              class="today-other-content"
              style="color: #2aa3d6;"
            >
              <span style="color: #FFF; font-weight: 800; font-size: medium;"><i class="far fa-clock"></i> Dernière Vente <br></span>
              {{ getLastSale(this.myData[0] != undefined && this.myData[0].sales != undefined ? this.myData[0].sales : undefined)}}
            </b-field>
          </div>

          <div class="today-progression">
            <b-field
              class="today-other-content"
              :style="getSalesRateStyle()"
            >
              <span style="color: #FFF; font-weight: 800; font-size: medium;"><i class="fas fa-analytics"></i> Ventes / Heure <br></span>
              {{ this.salesRate }}
            </b-field>
          </div>
        </div>
        <div
          v-if="hasGoalRecords || hasGoalSales"
          class="graph-container"
        >
          <ve-histogram
            :data="chartData"
            :settings="chartSettings2"
            :data-zoom="dataZoom"
          >
          </ve-histogram>
          <b-switch
            v-if="hasGoalRecords || hasGoalSales"
            v-model="isLive"
            style="padding-left: 25px;"
            true-value="Direct"
            false-value="Pause"
          >
            {{ isLive }}
          </b-switch>
        </div>
      </div>
    </div>
    <div class="mycard">
      <div
        v-if="hasPastGoals"
        class="past-card"
      >
        <h3 v-if="!isAdmin[0]"> Tous les Objectifs : </h3>
        <div class="past-card-widgets">
          <div class="goals">
            <div class="goal-selector-container">
              <div class="goal-selector">
                <b-field label="Date de l'objectif">
                  <b-datepicker
                    class="b-date-picker"
                    v-model="goalDate"
                    :focused-date="goalDate"
                    :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
                    :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
                    @input="dateSelected"
                    @change-month="selectMonth"
                    @change-year="selectYear"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :first-day-of-week="1"
                    indicators="dots"
                    :events="events"
                    :unselectable-days-of-week="[0, 6]"
                    placeholder="Choisir Date"
                  >
                  </b-datepicker>
                </b-field>
                <b-select
                  v-if="isAdmin[0]"
                  placeholder="Choisir l'objectif"
                  v-model="selectedGoal"
                  @input="goalSelected"
                >
                  <option
                    v-for="goal in goalsThisDate"
                    :key="goal.id"
                    :value="goal.id"
                  >{{ getWeezyName(goal.weezy_id)}}</option>
                </b-select>
              </div>
            </div>
            <div
              v-if="isAdmin[0]"
              class="goal-selector-container"
            >
              <div class="goal-selector">
                <b-field label="Objectif à Comparer">
                  <b-datepicker
                    class="b-date-picker"
                    v-model="compareDate"
                    :focused-date="compareDate"
                    :month-names="['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre']"
                    :day-names="['D', 'L', 'Ma', 'Me', 'J', 'V', 'S']"
                    @input="dateCompareSelected"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :first-day-of-week="1"
                    indicators="dots"
                    :events="events"
                    :unselectable-days-of-week="[0, 6]"
                    placeholder="Choisir Date"
                  >
                  </b-datepicker>
                </b-field>
                <b-select
                  v-if="isAdmin[0]"
                  placeholder="Choisir l'objectif"
                  v-model="selectedCompareGoal"
                  @input="goalCompareSelected"
                >
                  <option
                    v-for="goal in goalsThisCompareDate"
                    :key="goal.id"
                    :value="goal.id"
                  >{{ getWeezyName(goal.weezy_id)}}</option>
                </b-select>
              </div>
            </div>
            <div class="goal-recap">
              <div class="recap-content">
                <div class="recap-line">
                  <b-field
                    class="recap-field"
                    label="Progression"
                    :style="getColor(this.selected)"
                  >
                    <div
                      id="myProgress"
                      style="width : 100%; height: 20px; background-color: #CCC; border-radius: 20px; overflow: hidden"
                    >
                      <div
                        id="myBar"
                        :style="getProgressBarStyle(this.selected)"
                      >
                        {{ this.selected != undefined && this.selected.sales != undefined ? (this.selected.sales.length / this.selected.daily_sales_goal*100).toFixed(2) + "%": "N/A" }}
                      </div>
                    </div>
                  </b-field>
                  <b-field
                    class="recap-field"
                    label="Dernière Vente"
                  >
                    <div style="height: 20px; line-height: 20px;">
                      {{ getLastSale(this.selected != undefined && this.selected.sales != undefined ? this.selected.sales : undefined)}}
                    </div>
                  </b-field>
                  <b-field
                    class="recap-field"
                    label="Champion"
                  >
                    {{ getTopProducer(this.selected != undefined && this.selected.sales != undefined ? this.selected.sales : undefined)}}
                  </b-field>
                </div>
                <div class="recap-line">
                  <b-field
                    class="recap-field"
                    label="Objectif"
                  >
                    <div style="height: 20px; line-height: 20px;">
                      {{ this.selected != undefined ? this.selected.sales.length : "N/A" }} sur
                      {{ this.selected != undefined && this.selected.daily_sales_goal != undefined ? this.selected.daily_sales_goal + " Ventes" : "N/A"}}
                    </div>
                  </b-field>
                  <b-field
                    class="recap-field"
                    label="Campagne"
                  >
                    <div style="height: 20px; line-height: 20px;">
                      {{ this.selected != undefined && this.selected.weezy_id != undefined ? getCampaignName(this.selected.weezy_id) : "N/A" }}
                    </div>
                  </b-field>
                  <b-field class="recap-field">
                  </b-field>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="(hasGoalRecords || hasGoalSales) && isAdmin[0]"
            class="graph-container"
          >
            <ve-histogram
              :data="chartData"
              :settings="chartSettings"
              :data-zoom="dataZoom"
            >
            </ve-histogram>
          </div>
          <div
            v-if="selected == null  && isAdmin[0]"
            style="text-align: center; width: 100%; padding-top: 25px;"
          >
            Choisissez une date et un Objectif pour en voir le détail.
          </div>
          <div
            v-if="!(hasGoalRecords || hasGoalSales) && isAdmin[0] && selected != null"
            style="text-align: center; width: 100%; padding-top: 25px;"
          >
            Aucune donnée sonore, ni auncune vente disponible pour cet Objectif quotidien.
          </div>
          <b-switch
            v-if="(hasGoalRecords || hasGoalSales) && isAdmin[0]"
            v-model="isLive"
            style="padding-left: 50px;"
            true-value="Direct"
            false-value="Pause"
          >
            {{ isLive }}
          </b-switch>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import "echarts/lib/component/dataZoom";
import VeHistogram from "v-charts/lib/histogram.common";
import VCharts from "v-charts";

export default {
  name: "dashboardGoalsComponent",
  props: [
    "goals",
    "weezys",
    "campaigns",
    "users",
    "volume_records",
    "volume_compare_records",
    "isAdmin"
  ],
  components: { "ve-histogram": VeHistogram },
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      myData: [],
      selected: undefined,
      compareSelected: undefined,
      goalDate: new Date(),
      compareDate: new Date(),
      selectedGoal: undefined,
      selectedCompareGoal: undefined,
      hasTodayGoal: false,
      hasGoalRecords: false,
      hasGoalSales: false,
      hasPastGoals: false,
      events: [],
      podiumFirst: "N/A",
      podiumSecond: "",
      podiumThird: "",
      year: new Date().getFullYear(),
      month: new Date().getMonth(),
      minDate: new Date(),
      maxDate: new Date(),
      minCompareDate: new Date(),
      maxCompareDate: new Date(),
      salesRate: "",
      minimumRate: "",
      start: "",
      end: "",
      chartSettings: {
        metrics: [
          "Ventes",
          "Son Ambiant",
          "Ventes Comparées",
          "Son Ambiant Comparé"
        ],
        showLine: ["Son Ambiant Comparé", "Son Ambiant"]
      },
      chartSettings2: {
        metrics: ["Ventes", "Son Ambiant"],
        showLine: ["Son Ambiant"]
      },
      chartData: {
        columns: [
          "time",
          "Son Ambiant",
          "Ventes",
          "Ventes Comparées",
          "Son Ambiant Comparé"
        ],
        rows: []
      },
      dataZoom: [
        {
          type: "slider"
        }
      ],
      isLive: "Direct",
      isFullPage: false
    };
  },
  watch: {
    goals: function(newVal, oldVal) {
      // watch it
      var sorted = JSON.parse(JSON.stringify(this.goals)).sort(
        (a, b) =>
          new Date(b.activation_date_time) - new Date(a.activation_date_time)
      );
      this.myData = sorted;

      if (this.myData.length > 0) {
        var dayGoals = [];
        for (var i = 0; i < this.myData.length; i++) {
          if (
            this.compareDates(
              this.myData[i].activation_date_time,
              new Date()
            ) &&
            this.myData[i].is_active
          ) {
            dayGoals.push(this.myData[i]);
          }
        }
        // If several goals today, shows the latest activated one
        this.hasTodayGoal = dayGoals.length > 0;

        this.isLoading = false;
        this.getTopProducers(this.myData[0].sales);
        this.getSalesRate(
          this.myData[0] != undefined && this.myData[0].sales != undefined
            ? this.myData[0]
            : undefined
        );
        this.getGraphData();
        this.getEvents();
        this.getMaxDate();
        this.getMinDate();
      }
    },
    volume_records: function(newVal, oldVal) {
      // watch it
      this.getGraphData();
      this.getTopProducers(this.myData[0].sales);
    },
    volume_compare_records: function(newVal, oldVal) {
      // watch it
      this.getGraphData(true);
    },
    year: function(newVal, oldVal) {
      // watch it
      this.year = newVal;
      getUnselectableDates();
    },
    month: function(newVal, oldVal) {
      // watch it
      this.month = newVal;
      // getUnselectableDates()
    }
  },
  computed: {
    // Weezys with goals for selected GoalDate
    goalsThisDate: function() {
      return _.pickBy(
        this.goals,
        function(u) {
          let uDate = new Date(u.creation_date_time);
          return (
            uDate.getDate() +
              "/" +
              uDate.getMonth() +
              "/" +
              uDate.getFullYear() ==
            this.goalDate.getDate() +
              "/" +
              this.goalDate.getMonth() +
              "/" +
              this.goalDate.getFullYear()
          );
        }.bind(this)
      );
    },
    goalsThisCompareDate: function() {
      return _.pickBy(
        this.goals,
        function(u) {
          let uDate = new Date(u.creation_date_time);
          return (
            uDate.getDate() +
              "/" +
              uDate.getMonth() +
              "/" +
              uDate.getFullYear() ==
            this.compareDate.getDate() +
              "/" +
              this.compareDate.getMonth() +
              "/" +
              this.compareDate.getFullYear()
          );
        }.bind(this)
      );
    }
  },
  methods: {
    getGraphData(force = false) {
      var goal = undefined;
      if (this.isAdmin[0]) {
        //If supervisor : Show latest goal in full, the others are available also in full (without widgets)
        var dayGoals = [];
        for (var i = 0; i < this.myData.length; i++) {
          // if ((new Date(this.myData[i].activation_date_time).getDate() == new Date().getDate() && this.myData[i].is_active)){
          if (
            this.compareDates(
              this.myData[i].activation_date_time,
              new Date()
            ) &&
            this.myData[i].is_active
          ) {
            dayGoals.push(this.myData[i]);
          }
        }
        // If several goals today, shows the latest activated one
        dayGoals.sort(
          (a, b) =>
            new Date(b.activation_date_time) - new Date(a.activation_date_time)
        );
        if (this.selected == null) {
          if (dayGoals.length > 0) {
            this.selected = dayGoals[0];
          } else {
            // If no goals today, show last goal
            this.selected = this.myData[0];
            this.goalDate = new Date(this.selected.creation_date_time);
          }
          this.selectedGoal = this.selected.id;
        } else {
          // If goal is already selected, we need to update selected object with the same goal to get latest infos (such as is the func goalSelected())
          let keys = Object.keys(this.goalsThisDate);
          for (var i = 0; i < keys.length; i++) {
            if (this.goalsThisDate[keys[i]].id == this.selectedGoal) {
              this.selected = this.goalsThisDate[keys[i]];
            }
          }
        }
        goal = this.selected;
        if (this.selected != undefined) {
          if (
            this.$parent.weezyToGetRecordsFrom != this.selected.weezy_id &&
            this.selected.weezy_id != null
          ) {
            this.$parent.getVolumeRecords(
              this.selected.weezy_id,
              this.selected.id
            );
          }
          this.$parent.weezyToGetRecordsFrom = this.selected.weezy_id;
          this.$parent.goalToGetRecordsFrom = this.selected.id;
        }
      } else if (!this.isAdmin[0]) {
        //If supervisor : Show latest today goal in full, the others as a recap
        var dayGoals = [];
        for (var i = 0; i < this.myData.length; i++) {
          // if ((new Date(this.myData[i].activation_date_time).getDate() == new Date().getDate() && this.myData[i].is_active)){
          if (
            this.compareDates(
              this.myData[i].activation_date_time,
              new Date()
            ) &&
            this.myData[i].is_active
          ) {
            dayGoals.push(this.myData[i]);
          }
        }
        // If several goals today, shows the latest activated one
        dayGoals.sort(
          (a, b) =>
            new Date(b.activation_date_time) - new Date(a.activation_date_time)
        );
        goal = dayGoals[0];
        if (goal != undefined) {
          if (
            this.$parent.weezyToGetRecordsFrom != goal.weezy_id &&
            goal.weezy_id != null
          ) {
            this.$parent.getVolumeRecords(goal.weezy_id, goal.id);
          }
          this.$parent.weezyToGetRecordsFrom = goal.weezy_id;
          this.$parent.goalToGetRecordsFrom = goal.id;
        }
        if (this.selected == undefined) {
          // } else {
          // Shows last known goal if no goals today
          this.goalDate = new Date(this.myData[0].creation_date_time);
        }

        if (this.goalsThisDate.length > 0) {
          this.selectedGoal = this.goalsThisDate[
            Object.keys(this.goalsThisDate)[0]
          ].id;
        }
      }
      // Only updates when live is on, this helps to make the graph reactive when not in focus
      if (((this.isLive == "Direct" || force) && goal != undefined) || null) {
        var currentGoalVolumeRecords = [];
        var currentGoalCompareVolumeRecords = [];
        var currentGoalSales = [];
        var currentGoalCompareSales = [];

        var compareGoal = this.compareSelected;
        if (compareGoal != null && compareGoal.id != goal.id) {
          // ---------- COMPARE SELECTED OR CURRENT GOAL ------------
          for (var i = 0; i < this.volume_compare_records.length; i++) {
            if (this.volume_compare_records[i].goal_id == compareGoal.id) {
              var averaged = false;
              let record = this.volume_compare_records[i];
              let recordEntry = {
                time:
                  this.leadZero(
                    new Date(record.creation_date_time).getHours()
                  ).toString() +
                  ":" +
                  this.leadZero(
                    new Date(record.creation_date_time).getMinutes()
                  ).toString(),
                volume: record.volume / 10
              };

              // We do a volume record every 30seconds => We need to make an average if a same time is already present ...
              for (var j = 0; j < currentGoalCompareVolumeRecords.length; j++) {
                if (
                  recordEntry.time == currentGoalCompareVolumeRecords[j].time
                ) {
                  currentGoalCompareVolumeRecords[j].volume =
                    (recordEntry.volume +
                      currentGoalCompareVolumeRecords[j].volume) /
                    2;
                  averaged = true;
                }
              }
              if (!averaged) {
                currentGoalCompareVolumeRecords.push(recordEntry);
              }
            }
          }

          // For each moment in time, if there are already any sales, we add the sales to the saleEntry,
          // if there are no saleEntry for that time,
          for (var i = 0; i < compareGoal.sales.length; i++) {
            let added = false;
            let saleEntry = {
              time:
                this.leadZero(
                  new Date(compareGoal.sales[i].creation_date_time).getHours()
                ).toString() +
                ":" +
                this.leadZero(
                  new Date(compareGoal.sales[i].creation_date_time).getMinutes()
                ).toString(),
              sales: 1
            };
            for (var j = 0; j < currentGoalCompareSales.length; j++) {
              if (saleEntry.time == currentGoalCompareSales[j].time) {
                currentGoalCompareSales[j].sales++;
                added = true;
              }
            }

            if (!added) {
              currentGoalCompareSales.push(saleEntry);
            }
          }
        }

        // console.log("currentGoalCompareVolumeRecords :")
        // console.log(currentGoalCompareVolumeRecords)
        // console.log("currentGoalCompareSales :")
        // console.log(currentGoalCompareSales)

        // ---------- FIRST SELECTED OR CURRENT GOAL ------------
        for (var i = 0; i < this.volume_records.length; i++) {
          if (this.volume_records[i].goal_id == goal.id) {
            var averaged = false;
            let record = this.volume_records[i];
            let recordEntry = {
              time:
                this.leadZero(
                  new Date(record.creation_date_time).getHours()
                ).toString() +
                ":" +
                this.leadZero(
                  new Date(record.creation_date_time).getMinutes()
                ).toString(),
              volume: record.volume / 10
            };

            // We do a volume record every 30seconds => We need to make an average if a same time is already present ...
            for (var j = 0; j < currentGoalVolumeRecords.length; j++) {
              if (recordEntry.time == currentGoalVolumeRecords[j].time) {
                currentGoalVolumeRecords[j].volume =
                  (recordEntry.volume + currentGoalVolumeRecords[j].volume) / 2;
                averaged = true;
              }
            }
            if (!averaged) {
              currentGoalVolumeRecords.push(recordEntry);
            }
          }
        }

        // For each moment in time, if there are already any sales, we add the sales to the saleEntry,
        // if there are no saleEntry for that time,
        for (var i = 0; i < goal.sales.length; i++) {
          let added = false;
          let saleEntry = {
            time:
              this.leadZero(
                new Date(goal.sales[i].creation_date_time).getHours()
              ).toString() +
              ":" +
              this.leadZero(
                new Date(goal.sales[i].creation_date_time).getMinutes()
              ).toString(),
            sales: 1
          };
          for (var j = 0; j < currentGoalSales.length; j++) {
            if (saleEntry.time == currentGoalSales[j].time) {
              currentGoalSales[j].sales++;
              added = true;
            }
          }

          if (!added) {
            currentGoalSales.push(saleEntry);
          }
        }

        this.hasGoalRecords = currentGoalVolumeRecords.length > 0;
        this.hasGoalSales = currentGoalSales.length > 0;
        var data = [];
        // ------------------- FINSH GRAPH WITH ALL DATA -------------------
        // To finish, for every moment we add the sales and time as an entry.
        // This leads us to have one array of objects, each having time, Son_Ambiant, Ventes

        //MERGE CURRENT VOLUME & SALES
        var mergedCurrentVolumeAndSales = currentGoalVolumeRecords
          .concat(currentGoalSales)
          .reduce((acc, x) => {
            acc[x.time] = Object.assign(acc[x.time] || {}, x);
            return acc;
          }, {});
        _.values(mergedCurrentVolumeAndSales);

        var currentVolumeAndSalesArray = [];
        for (var key in mergedCurrentVolumeAndSales) {
          var obj = mergedCurrentVolumeAndSales[key];
          currentVolumeAndSalesArray.push({
            time: obj.time,
            "Son Ambiant": obj.volume ? obj.volume : undefined,
            Ventes: obj.sales ? obj.sales : 0
          });
        }

        //MERGE COMPARISON VOLUME & SALES
        var mergedCompareVolumeRecordsAndSales = currentGoalCompareVolumeRecords
          .concat(currentGoalCompareSales)
          .reduce((acc, x) => {
            acc[x.time] = Object.assign(acc[x.time] || {}, x);
            return acc;
          }, {});
        _.values(mergedCompareVolumeRecordsAndSales);

        var comparedVolumeAndSalesArray = [];
        for (var key in mergedCompareVolumeRecordsAndSales) {
          var obj = mergedCompareVolumeRecordsAndSales[key];
          comparedVolumeAndSalesArray.push({
            time: obj.time,
            "Son Ambiant Comparé": obj.volume ? obj.volume : undefined,
            "Ventes Comparées": obj.sales ? obj.sales : 0
          });
        }

        //MERGE BOTH CURRENT AND COMPARISON
        var mergedCurrentAndCompared = currentVolumeAndSalesArray
          .concat(comparedVolumeAndSalesArray)
          .reduce((acc, x) => {
            acc[x.time] = Object.assign(acc[x.time] || {}, x);
            return acc;
          }, {});
        _.values(mergedCurrentAndCompared);

        for (var key in mergedCurrentAndCompared) {
          var obj = mergedCurrentAndCompared[key];
          data.push({
            time: obj.time,
            "Son Ambiant": obj["Son Ambiant"] ? obj["Son Ambiant"] : undefined,
            Ventes: obj.Ventes ? obj.Ventes : 0,
            "Son Ambiant Comparé": obj["Son Ambiant Comparé"]
              ? obj["Son Ambiant Comparé"]
              : undefined,
            "Ventes Comparées": obj["Ventes Comparées"]
              ? obj["Ventes Comparées"]
              : 0
          });
        }

        data.sort(function(a, b) {
          return (
            new Date("1970/01/01 " + a.time) - new Date("1970/01/01 " + b.time)
          );
        });
        this.chartData.rows = data;
      }
    },
    getProgressBarStyle(selected) {
      if (selected != undefined) {
        var value = (
          (selected.sales.length / selected.daily_sales_goal) *
          100
        ).toFixed(2);
        value = Math.min(value, 100);
        return (
          "width: " +
          value +
          "%; height: 20px; background-color: #4CAF50; text-align: center; line-height: 20px; color: white;  border-top-right-radius: 7px; border-bottom-right-radius: 7px;"
        );
      }
    },
    selectMonth(option) {
      this.month = option.value;
    },
    selectYear(option) {
      this.year = option.value;
    },
    dateFormatter(value) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return days + "-" + months + "-" + years;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    getCampaignName(FromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        var weezy = this.weezys[i];
        if (weezy.id == FromWeezyId) {
          for (var j = 0; j < this.campaigns.length; j++) {
            if (weezy.campaign_id == this.campaigns[j].id) {
              return this.campaigns[j].name;
            }
          }
        }
      }
    },
    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    },
    getColor(row) {
      if (row != undefined && row.sales != undefined) {
        let percent = (row.sales.length / row.daily_sales_goal) * 100;
        if (percent >= 100) {
          return "color: #0000BB;";
        } else if (percent >= 90) {
          return "color: #00AA00;";
        } else if (percent >= 70) {
          return "color: #66AA00;";
        } else if (percent >= 50) {
          return "color: #AAAA00;";
        } else if (percent >= 25) {
          return "color: #BB4400;";
        } else {
          return "color: #DD0000;";
        }
      }
    },
    getTopProducer(sales) {
      if (sales != undefined) {
        var userId = "";
        var maxSales = 0;
        for (var i = 0; i < this.users.length; i++) {
          var count = 0;
          for (var j = 0; j < sales.length; j++) {
            if (sales[j].user_id == this.users[i].id) {
              count++;
            }
          }
          if (count > maxSales) {
            maxSales = count;
            userId = this.users[i].id;
          }
        }
        if (maxSales == 0) {
          return "N/A";
        } else {
          return this.getUserName(userId);
        }
      } else {
        return "N/A";
      }
    },
    getTopProducers(sales) {
      if (sales != undefined) {
        var usersSales = [];
        var maxSales = 0;
        var users = [];
        for (let sale of sales) {
          users.push(sale.user_id);
        }
        users = [...new Set(users)];
        for (var i = 0; i < users.length; i++) {
          var count = 0;
          for (var j = 0; j < sales.length; j++) {
            if (sales[j].user_id == users[i]) {
              count++;
            }
          }
          if (count > maxSales) {
            maxSales = count;
          }
          usersSales.push({
            user: users[i],
            sales: count
          });
          usersSales.sort((a, b) => b.sales - a.sales);
        }
        if (usersSales.length > 0) {
          this.podiumFirst = "1. " + this.getUserName(usersSales[0].user);
        }
        if (usersSales.length > 1) {
          this.podiumSecond = "2. " + this.getUserName(usersSales[1].user);
        }
        if (usersSales.length > 2) {
          this.podiumThird = "3. " + this.getUserName(usersSales[2].user);
        }
      }
    },
    getLastSale(sales) {
      if (sales != undefined) {
        var tempSales = JSON.parse(JSON.stringify(sales));
        tempSales.sort(
          (a, b) =>
            new Date(b.creation_date_time) - new Date(a.creation_date_time)
        );
        if (tempSales.length > 0) {
          var sale = tempSales[0];
          return this.getUserName(sale.user_id);
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    },
    getSalesRate(goal) {
      if (goal != undefined && goal.sales != undefined) {
        var currTime =
          new Date().getHours() + new Date().getMinutes() * (1 / 60);
        // currtime is formatted like this : 12,5 hours == 12h30 or 9,75 == 9h45
        var tempSales = JSON.parse(JSON.stringify(goal.sales));
        tempSales.sort(
          (b, a) =>
            new Date(b.creation_date_time) - new Date(a.creation_date_time)
        );
        if (tempSales.length > 0) {
          var sale = tempSales[0];
          var startTime =
            new Date(goal.activation_date_time).getHours() +
            new Date(goal.activation_date_time).getMinutes() * (1 / 60);
          var diff = currTime - startTime > 0 ? currTime - startTime : 1;
          this.salesRate = (goal.sales.length / diff).toFixed(2);
          this.minimumRate = goal.daily_sales_goal / 8; // IMPORTANT :  8 corresponds to 8 hours of work in a day
        } else {
          return "N/A ";
        }
      } else {
        return "N/A";
      }
    },
    getSalesRateStyle() {
      var diff =
        Math.min(this.minimumRate, this.salesRate) /
        Math.max(this.minimumRate, this.salesRate);
      diff = (1 - diff) * 100;
      if (diff > 10) {
        if (this.minimumRate > this.salesRate) {
          return "color: #AA0000;";
        } else {
          return "color: #00AA00;";
        }
      } else {
        return "color: #2aa3d6;";
      }
    },
    getUserName(fromUserId) {
      for (var i = 0; i < this.users.length; i++) {
        if (fromUserId == this.users[i].id) {
          return this.users[i].name + " " + this.users[i].surname;
        }
      }
    },
    sortByCreation(a, b, isAsc) {
      if (isAsc) {
        return new Date(b.creation_date_time) - new Date(a.creation_date_time);
      } else {
        return new Date(a.creation_date_time) - new Date(b.creation_date_time);
      }
    },
    sortByProgression(a, b, isAsc) {
      if (isAsc) {
        return (
          b.sales.length / b.daily_sales_goal -
          a.sales.length / a.daily_sales_goal
        );
      } else {
        return (
          a.sales.length / b.daily_sales_goal -
          b.sales.length / a.daily_sales_goal
        );
      }
    },
    getProgressWidget(goal) {
      let value =
        goal != undefined && goal.sales
          ? ((goal.sales.length / goal.daily_sales_goal) * 100).toFixed(2)
          : 0;
      var curve = 0;
      if (value > 60) {
        curve = 35;
      } else if (value > 35) {
        curve = 30;
      } else if (value > 25) {
        curve = 35;
      } else if (value > 15) {
        curve = 50;
      } else {
        curve = 60;
      }
      return (
        "height: " +
        (100 - value > 0 ? 100 - value : 0) +
        "%; border-bottom-left-radius: " +
        curve +
        "px; border-bottom-right-radius: " +
        curve +
        "px;"
      );
    },
    dateSelected() {
      this.selected = null;
      if (this.isAdmin[0]) {
        for (var i = 0; i < this.myData.length; i++) {
          if (
            this.goalDate.getDate() ==
            new Date(this.myData[i].creation_date_time).getDate()
          ) {
            this.selected = this.goalsThisDate[
              Object.keys(this.goalsThisDate)[0]
            ];
            this.selectedGoal = this.goalsThisDate[
              Object.keys(this.goalsThisDate)[0]
            ].id;
          }
        }
      } else {
        for (var i = 0; i < this.myData.length; i++) {
          if (
            this.goalDate.getDate() ==
            new Date(this.myData[i].creation_date_time).getDate()
          ) {
            this.selected = this.goalsThisDate[
              Object.keys(this.goalsThisDate)[0]
            ];
          }
        }
      }
    },
    dateCompareSelected() {
      this.compareSelected = null;
      if (this.isAdmin[0]) {
        for (var i = 0; i < this.myData.length; i++) {
          if (
            this.compareDate.getDate() ==
            new Date(this.myData[i].creation_date_time).getDate()
          ) {
            this.compareSelected = this.goalsThisCompareDate[
              Object.keys(this.goalsThisCompareDate)[0]
            ];
            this.selectedCompareGoal = this.goalsThisCompareDate[
              Object.keys(this.goalsThisCompareDate)[0]
            ].id;
          }
        }
      }
    },
    goalSelected() {
      this.selected = null;
      let keys = Object.keys(this.goalsThisDate);
      for (var i = 0; i < keys.length; i++) {
        if (this.goalsThisDate[keys[i]].id == this.selectedGoal) {
          this.selected = this.goalsThisDate[keys[i]];
          this.$parent.getVolumeRecords(
            this.selected.weezy_id,
            this.selected.id
          );
          this.$parent.weezyToGetRecordsFrom = this.selected.weezy_id;
          this.$parent.goalToGetRecordsFrom = this.selected.id;
        }
      }
      this.getGraphData(true);
    },
    goalCompareSelected() {
      this.compareSelected = null;
      let keys = Object.keys(this.goalsThisCompareDate);
      for (var i = 0; i < keys.length; i++) {
        if (this.goalsThisCompareDate[keys[i]].id == this.selectedCompareGoal) {
          this.compareSelected = this.goalsThisCompareDate[keys[i]];
          this.$parent.getCompareVolumeRecords(
            this.compareSelected.weezy_id,
            this.compareSelected.id
          );
        }
      }
      this.getGraphData();
    },
    getEvents() {
      const thisMonth = new Date().getMonth();
      var tempEvents = [];
      for (var i = 0; i < this.myData.length; i++) {
        var goalDate = new Date(this.myData[i].creation_date_time);
        tempEvents.push({
          date: new Date(
            goalDate.getFullYear(),
            goalDate.getMonth(),
            goalDate.getDate()
          ),
          type: "is-danger"
        });
      }
      this.events = tempEvents;
      if (this.events.length > 0) {
        this.hasPastGoals = true;
        if (
          this.selected == undefined &&
          this.myData.length > 0 &&
          !this.isAdmin[0]
        ) {
          this.selected = this.myData[0];
        }
      }
    },
    getUnselectableDates() {
      console.log(this.month);
      console.log(this.year);
      //TODO: if wanted ...
    },
    getMaxDate() {
      return new Date();
    },
    getMinDate() {
      if (this.events.length > 0) {
        this.events.sort((a, b) => b.date - a.date);
        this.minDate = this.events[this.events.length - 1].date;
      }
    },
    getFullDate(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    compareDates(dateA, dateB) {
      return (
        JSON.stringify(this.getFullDate(new Date(dateA))) ==
        JSON.stringify(this.getFullDate(new Date(dateB)))
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/* PHONE SIZE */
@media screen and (max-width: 768px) {
  .graph-container {
    display: none !important;
  }
}

.graph-container {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}

.b-input-number {
  width: 59px;
}

.has-text-centered {
  max-width: 80%;
  background-color: #2aa3d644;
}

.has-text-centered .selected {
  max-width: 80%;
  background-color: rgb(42, 163, 214);
}

.select {
  width: 200px !important;
}

.section {
  padding: 0%;
  display: grid;
}

h2 {
  font-size: 2em;
  color: rgb(42, 163, 214);
  height: 20px;
}

h3 {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 20px;
  height: 15px;
  font-size: 1.5em;
  color: rgb(42, 163, 214);
}

.goals {
  display: flex;
  justify-content: space-evenly;
}

.goal-recap {
  background-color: #2aa3d622;
  border-radius: 10px;
  max-width: 800px;
  min-width: 400px;
}

.goal-selector-container {
  background-color: #2aa3d622;
  border-radius: 10px;
  width: 173px;

  .goal-selector {
    padding: 10px;
  }
}

.recap-content {
  padding: 10px;
}

.recap-field {
  width: fit-content;
  margin-bottom: 0px;
}

.recap-line {
  display: flex;
  justify-content: space-between;
}

.mycard {
  padding-top: 10px;
  padding-right: 10px;
  box-shadow: none;
}

.today-card {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.today-card-widgets {
  display: flex;
  justify-content: space-evenly;
  padding-bottom: 0px;
}
.past-card {
  background-color: #2aa3d622;
  border-radius: 10px;
  padding-bottom: 10px;
}

.past-card-widgets {
  padding-top: 10px;
  padding-left: 1px;
  padding-bottom: 10px;
}

.today-progression {
  background-color: #2aa3d666;
  width: 175px;
  height: 175px;
  border-radius: 50%;
  overflow: hidden;
}

.today-progression-over {
  background-color: #2aa3d666;
  width: 175px;
  height: 175px;
  border-radius: 50%;
  overflow: hidden;
}

.today-progression-content {
  text-align: center;
  height: 175px;
  width: 175px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1.5em;
}

.today-progressbar {
  background-color: #00000044;
  width: 175px;
}

.today-podium-content {
  text-align: center;
  height: 175px;
  width: 175px;
  padding-left: 2px;
  padding-right: 2px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1em;
}

.today-other-content {
  text-align: center;
  height: 175px;
  width: 175px;
  padding-left: 2px;
  padding-right: 2px;
  display: table-cell;
  vertical-align: middle;
  font-weight: 700;
  font-size: 1.4em;
}
</style>